module.exports = __webpack_public_path__ + "friends/assets/img/logo.76a9bb10.svg";